<template>
  <div
    class="p-contentplans-writing-ai"
    :style="{ maxHeight: maxHeight, top: notificationsHeight + 'px' }"
    ref="aiContainer"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      maxHeight: 'none'
    };
  },
  computed: {
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    }
  },
  watch: {
    notificationsHeight: {
      handler() {
        this.setHeight();
      }
    }
  },
  mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  },
  methods: {
    scroll(el) {
      if (!el) {
        return;
      }
      this.$nextTick(() => {
        const elRect = el.getBoundingClientRect();
        const top = elRect.top - this.notificationsHeight - 32;
        this.$refs.aiContainer.scrollBy({ top, behavior: 'smooth' });
      });
    },
    setHeight() {
      this.$nextTick(() => {
        const maxHeight =
          document.documentElement.clientHeight - this.notificationsHeight;
        this.maxHeight = maxHeight + 'px';
      });
    }
  }
};
</script>
